module.exports = __webpack_public_path__ + "static/media/chart1.5cc0a287.jpeg";